/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Detect_Overlap_TooltipInputs */

const en_style_guide_manager_detect_overlap_tooltip = /** @type {(inputs: Style_Guide_Manager_Detect_Overlap_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check that event times do not overlap with another event(s).`)
};

const fr_style_guide_manager_detect_overlap_tooltip = /** @type {(inputs: Style_Guide_Manager_Detect_Overlap_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifier que les temps d'evenement ne se chevauchent pas avec d'autres evenements.`)
};

const de_style_guide_manager_detect_overlap_tooltip = /** @type {(inputs: Style_Guide_Manager_Detect_Overlap_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüfen Sie, ob sich die Veranstaltungszeiten nicht mit anderen Veranstaltungen überschneiden.`)
};

const it_style_guide_manager_detect_overlap_tooltip = /** @type {(inputs: Style_Guide_Manager_Detect_Overlap_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificare che gli orari degli eventi non si sovrappongano con altri eventi.`)
};

const ru_style_guide_manager_detect_overlap_tooltip = /** @type {(inputs: Style_Guide_Manager_Detect_Overlap_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Убедитесь, что время проведения мероприятий не совпадает со временем проведения других мероприятий.`)
};

const es_style_guide_manager_detect_overlap_tooltip = /** @type {(inputs: Style_Guide_Manager_Detect_Overlap_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifique que los horarios de los eventos no se superpongan con los de otros eventos.`)
};

const zh_cn2_style_guide_manager_detect_overlap_tooltip = /** @type {(inputs: Style_Guide_Manager_Detect_Overlap_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检查活动时间是否与其他活动重叠。`)
};

const ja_style_guide_manager_detect_overlap_tooltip = /** @type {(inputs: Style_Guide_Manager_Detect_Overlap_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントの時間が他のイベントと重複していないことを確認してください。`)
};

const hi_style_guide_manager_detect_overlap_tooltip = /** @type {(inputs: Style_Guide_Manager_Detect_Overlap_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह सुनिश्चित करें कि किसी कार्यक्रम का समय किसी अन्य कार्यक्रम के समय से मेल न खाए।`)
};

const pt_pt2_style_guide_manager_detect_overlap_tooltip = /** @type {(inputs: Style_Guide_Manager_Detect_Overlap_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifique se os horários dos eventos não se sobrepõem a outros eventos.`)
};

/**
* | output |
* | --- |
* | "Check that event times do not overlap with another event(s)." |
*
* @param {Style_Guide_Manager_Detect_Overlap_TooltipInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_detect_overlap_tooltip = /** @type {((inputs?: Style_Guide_Manager_Detect_Overlap_TooltipInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Detect_Overlap_TooltipInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_detect_overlap_tooltip(inputs)
	if (locale === "de") return de_style_guide_manager_detect_overlap_tooltip(inputs)
	if (locale === "it") return it_style_guide_manager_detect_overlap_tooltip(inputs)
	if (locale === "ru") return ru_style_guide_manager_detect_overlap_tooltip(inputs)
	if (locale === "es") return es_style_guide_manager_detect_overlap_tooltip(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_detect_overlap_tooltip(inputs)
	if (locale === "ja") return ja_style_guide_manager_detect_overlap_tooltip(inputs)
	if (locale === "hi") return hi_style_guide_manager_detect_overlap_tooltip(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_detect_overlap_tooltip(inputs)
	return en_style_guide_manager_detect_overlap_tooltip(inputs)
});